import { useEffect } from 'react';
import { PROJECTS } from '../../../routes/path';
import { useNavigate } from 'react-router-dom';
import { useAccount } from '../../../contexts/account/AccountContexts';

const useProjectNavigate = (projectId: number) => {
  const navigate = useNavigate();
  const { projectResponse } = useAccount();

  useEffect(() => {
    const projectsIds = projectResponse?.map((project) => project.id);
    if (isNaN(projectId) || !projectsIds?.includes(projectId)) {
      navigate(PROJECTS);
    }
  }, []);
};

export default useProjectNavigate;
